import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;
  const isServicesActive = () => {
    const servicePaths = [
      '/remodelacoes',
      '/pintura',
      '/pavimento-madeira',
      '/pavimentacao-ceramica',
      '/instalacao-moveis',
      '/moveis-medida',
      '/servicos'
    ];
    return servicePaths.includes(location.pathname);
  };

  const serviceLinks = [
    { path: '/remodelacoes', label: 'Remodelações Gerais' },
    { path: '/pintura', label: 'Pintura' },
    { path: '/pavimento-madeira', label: 'Pavimento em Madeira' },
    { path: '/pavimentacao-ceramica', label: 'Pavimentação em Cerâmica' },
    { path: '/instalacao-moveis', label: 'Instalação de Móveis' },
    { path: '/moveis-medida', label: 'Móveis por Medida' },
  ];

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md shadow-sm z-50 transition-all duration-300">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-24">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <img
              src="/images/logo/MM_Carpintaria_logo_transparente.webp"
              alt="MM Carpintaria Logo"
              className="h-20 w-auto object-contain transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          <nav className="hidden lg:flex items-center gap-10">
            <Link
              to="/"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/') ? 'text-mmcarpintaria-green' : 'text-gray-800 hover:text-mmcarpintaria-green'
                }`}
            >
              Home
            </Link>

            {/* Dropdown de Serviços */}
            <div className="relative group">
              <button
                className={`flex items-center gap-1 text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isServicesActive() ? 'text-mmcarpintaria-green' : 'text-gray-800 hover:text-mmcarpintaria-green'
                  }`}
              >
                Serviços <i className="ri-arrow-down-s-line transition-transform group-hover:rotate-180"></i>
              </button>

              <div className="absolute top-full left-0 w-72 bg-white shadow-xl rounded-sm py-3 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform translate-y-4 group-hover:translate-y-0 border-t-4 border-mmcarpintaria-green">
                <Link
                  to="/servicos"
                  className="block px-6 py-3 text-sm text-gray-800 hover:bg-gray-50 hover:text-mmcarpintaria-green font-bold border-b border-gray-100 transition-colors"
                >
                  VER TODOS OS SERVIÇOS
                </Link>
                {serviceLinks.map((service) => (
                  <Link
                    key={service.path}
                    to={service.path}
                    className={`block px-6 py-3 text-sm hover:bg-gray-50 hover:text-mmcarpintaria-green transition-colors font-medium border-b border-gray-50 last:border-0 ${isActive(service.path) ? 'text-mmcarpintaria-green bg-gray-50' : 'text-gray-600'
                      }`}
                  >
                    {service.label}
                  </Link>
                ))}
              </div>
            </div>

            <Link
              to="/galeria"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/galeria') ? 'text-mmcarpintaria-green' : 'text-gray-800 hover:text-mmcarpintaria-green'
                }`}
            >
              Galeria
            </Link>

            <Link
              to="/blog"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/blog') ? 'text-mmcarpintaria-green' : 'text-gray-800 hover:text-mmcarpintaria-green'
                }`}
            >
              Blog
            </Link>

            <Link
              to="/sobre"
              className={`text-xs font-bold tracking-widest uppercase transition-colors cursor-pointer whitespace-nowrap ${isActive('/sobre') ? 'text-mmcarpintaria-green' : 'text-gray-800 hover:text-mmcarpintaria-green'
                }`}
            >
              Sobre nós
            </Link>
          </nav>

          <div className="hidden lg:flex items-center gap-4">
            <a
              href="https://wa.me/351964759517?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-mmcarpintaria-green text-white rounded-sm font-bold uppercase text-xs tracking-widest hover:bg-mmcarpintaria-green-dark transition-all cursor-pointer whitespace-nowrap shadow-md hover:shadow-lg hover:-translate-y-0.5 flex items-center gap-2"
            >
              <i className="ri-whatsapp-line text-lg"></i>
              Orçamento
            </a>
          </div>

          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
          >
            <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>
      </div>

      {isMenuOpen && (
        <div className="lg:hidden bg-white/95 backdrop-blur-md border-t border-gray-100 max-h-[calc(100vh-96px)] overflow-y-auto">
          <nav className="container mx-auto px-6 py-6 flex flex-col gap-2">
            <Link to="/" className="py-3 px-4 text-gray-800 hover:text-mmcarpintaria-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Home
            </Link>

            {/* Mobile Services Accordion */}
            <div className="py-2">
              <button
                onClick={() => setIsServicesOpen(!isServicesOpen)}
                className="flex items-center justify-between w-full py-3 px-4 text-gray-800 hover:text-mmcarpintaria-green cursor-pointer font-bold uppercase tracking-widest text-xs"
              >
                <span>Serviços</span>
                <i className={`ri-arrow-down-s-line transition-transform ${isServicesOpen ? 'rotate-180' : ''}`}></i>
              </button>

              {isServicesOpen && (
                <div className="pl-6 mt-2 flex flex-col gap-1 border-l-2 border-mmcarpintaria-green ml-4">
                  <Link
                    to="/servicos"
                    className="py-3 px-4 text-xs text-mmcarpintaria-green font-bold uppercase tracking-wide hover:bg-gray-50 rounded-sm"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    Ver Todos
                  </Link>
                  {serviceLinks.map((service) => (
                    <Link
                      key={service.path}
                      to={service.path}
                      className="py-3 px-4 text-xs text-gray-600 hover:text-mmcarpintaria-green hover:bg-gray-50 rounded-sm uppercase tracking-wide"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      {service.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>

            <Link to="/blog" className="py-3 px-4 text-gray-800 hover:text-mmcarpintaria-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Blog
            </Link>

            <Link to="/galeria" className="py-3 px-4 text-gray-800 hover:text-mmcarpintaria-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Galeria
            </Link>

            <Link to="/sobre" className="py-3 px-4 text-gray-800 hover:text-mmcarpintaria-green cursor-pointer hover:bg-gray-50 rounded-sm font-bold uppercase tracking-widest text-xs" onClick={() => setIsMenuOpen(false)}>
              Sobre nós
            </Link>
            <a
              href="https://wa.me/351964759517?text=Olá,%20gostaria%20de%20solicitar%20um%20orçamento"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 px-5 py-4 bg-mmcarpintaria-green text-white rounded-sm font-bold uppercase tracking-widest text-xs text-center cursor-pointer whitespace-nowrap shadow-md"
            >
              Solicitar Orçamento
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}